import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BookMarkService {
  folderData: any
  constructor(private http: HttpClient) {}

  getBookMark(body: any): Observable<any> {
    return this.http.post<any>('/bookmark/create/', body);
  }

  getAllBookMark(mapId: any) {
    return this.http.get('/bookmark/get-all/', {
      params: {
        map_id: parseInt(mapId),
      },
    });
  }
  bookMarkDefaultView(body: any) {
    return this.http.put<any>('/bookmark/default-view/', body, {});
  }
  renamebookMark(body: any) {
    return this.http.put<any>('/bookmark/rename/', body, {});
  }
  deletbookMark(body: any) {
    return this.http.put<any>('/bookmark/delete/', body, {});
  }
  deleteMultipleBookmark(body: any) {
    return this.http.put<any>('/bookmark/delete-multiple/', body, {});
  }

  deletbookMarkFolder(folderId: any) {
    return this.http.delete<any>(`/folder/viewset/${parseInt(folderId)}/`);
  }
  updatebookMarkFolder(folderId: any, body: any) {
    return this.http.patch<any>(`/folder/viewset/${parseInt(folderId)}/`, body,);
  }
}
